import React from "react";
import { Headline, Link, SectionContent } from "../../../../components";
import { applyKey } from "../../../../utils";

const SampleLinks = () => {
  return (
    <SectionContent>
      <Headline nivel="2" styleAs="3" text="Links" />
      {applyKey(["sm", "md", "lg", "xl"], (size) => (
        <>
          <Link href="#link" label={`Link ${size}`} textSize={size} />
          <br />
          {size !== "xl" ? (
            <Link
              href="#link"
              label={`Link forte ${size}`}
              textSize={size}
              textStrong
            />
          ) : null}
          <br />
        </>
      ))}

      <Link href="#link" label="Link disabilitado" disabled />
    </SectionContent>
  );
};

SampleLinks.propTypes = {};

export default SampleLinks;
